import React from "react";

type ExclusiveBadgeProps = {
  className?: string;
};

const ExclusiveBadge = ({ className }: ExclusiveBadgeProps) => {
  return (
    <img
      src="/assets/images/subscription-competitions/exclusive-badge.webp"
      alt="exclusive subscriber"
      width={92}
      height={29}
      className={`w-[92px] lg:w-[139px] aspect-[92/29] ${className ? className : ""}`}
    />
  );
};

export default ExclusiveBadge;
